<template>
	<form-field-wrap
			:field-props="fieldProps"
			:is-error="isError"
			:field-value="fieldValue"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
			:is-recaptcha="isRecaptcha"
	>
		<template v-if="isRecaptcha" slot="recaptcha">
			<div class="form-field-container">
				<div class="recaptcha">
					<vue-recaptcha
							ref="recaptcha"
							:sitekey="recaptchaKey"
							:load-recaptcha-script="true"
							@verify="changeValue"
					></vue-recaptcha>
					<input type="hidden"
					       autocomplete="off"
					       v-validate="rules"
					       :data-vv-as="fieldProps.TITLE"
					       :name="fieldProps.CODE"
					       :value="fieldValue"
					       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE">
				</div>
				<div class="error_block" v-show="isError">
					<span class="error_text" v-html="isError"></span>
				</div>
			</div>
		</template>
		<template v-else>
			<input class="form-control form-field-input"
			       type="text"
			       autocomplete="off"
			       v-validate="rules"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       @input="changeValue"
			       @focus="labelSwitch('focus')"
			       @blur="labelSwitch">
			<template slot="captcha-img">
				<div class="captcha-img" style="margin-top: 20px;">
					<img :src="'/bitrix/tools/captcha.php?captcha_code='+fieldProps.CAPTCHA_CODE" style="width: auto;">
				</div>
			</template>
		</template>
	</form-field-wrap>
</template>

<script>
	export default {
		name: "FormFieldCaptcha",
		props: {
			isRecaptcha: {
				type: Boolean,
				default: false
			},
			recaptchaKey: {
				type: String,
				default: "",
			}
		},
		methods: {
			changeValue: function ($event) {
				if (this.isRecaptcha) {
					this.inputValue = $event
					this.$emit('input', $event);
					setTimeout(() => {
						this.$validator.validate();
					}, 100);
				} else {
					this.inputValue = $event.target.value;
					this.$emit('input', $event.target.value);
				}
			},
			async resetValid() {
				this.$validator.reset();
			},
			onCaptchaExpired() {
				this.changeValue("");
			},
		},
	}
</script>